import { safeApiRequest } from './apiClient';

export const fetchAnketOzet = () => safeApiRequest('/api/anketler/ozet');

export const fetchAnketler = ({ hedef, set, sayfa } = {}) => safeApiRequest('/api/anketler', {
  query: { hedef, set, sayfa },
});

export const fetchAnketSorulari = (set) => safeApiRequest('/api/anketler/sorular', { query: set ? { set } : {} });

export const createAnketSoru = (body) => safeApiRequest('/api/anketler/sorular', { method: 'POST', body });

export const updateAnketSoru = (id, body) => safeApiRequest(`/api/anketler/sorular/${id}`, { method: 'PUT', body });

export const siralaAnketSorulari = (set, idler) => safeApiRequest('/api/anketler/sorular/sira', {
  method: 'PUT',
  body: { set, idler },
});

export const fetchAnketKampanyalari = (sayfa) => safeApiRequest('/api/anketler/kampanyalar', { query: { sayfa } });

export const createAnketKampanya = (body) => safeApiRequest('/api/anketler/kampanyalar', { method: 'POST', body });

export const fetchAnketAlicilar = ({ hedef, q }) => safeApiRequest('/api/anketler/alicilar', { query: { hedef, q } });

export const fetchAcikAnketler = () => safeApiRequest('/api/anketler/benim');
